import { financeStatusOptions } from 'Modules/Plans/Finance/Dashboard/components/UnallocatedCampaigns/components/FinanceStatusCell/helpers';
import colors from 'Modules/Plans/Finance/Dashboard/components/UnallocatedCampaigns/components/FinanceStatusCell/FinanceStatusBadge/colors';
import { creatorbase } from '@round/api';
import { Select } from '@round/whitelabel-ui';
import { SingleValueProps, StylesConfig, ValueType } from 'react-select';
import { GenericDropdownOption } from 'App.types';
import styles from './AllocationCell.module.css';

type Value = ValueType<GenericDropdownOption<creatorbase.FinanceStatus>, false>;

const getValue = (value: ValueType<{}, boolean>): Value => {
    return (Array.isArray(value) && value.length === 1 ? value[0] : value) as Value;
};

const selectStyles: StylesConfig = {
    container: (base) => ({
        ...base,
        background: 'var(--Surface-White)',
        borderRadius: '0.75rem',
    }),
    control: (base, state) => {
        const value = getValue(state.getValue());
        const { background, color } = colors[value?.value!];
        return {
            ...base,
            padding: '0.125rem 0.75rem',
            border: 'none',
            borderRadius: '0.75rem',
            columnGap: '0.25rem',
            background,
            color,
            ':hover': {
                padding: '0.125rem 0.75rem',
                border: 'none',
                borderRadius: '0.75rem',
                background,
                color,
            },
            '& input[readonly]': {
                height: 0,
            },
        };
    },
    indicatorsContainer: (base) => ({
        ...base,
        padding: 0,
        height: 'auto',
        color: 'inherit',
        ':hover': {
            padding: 0,
            height: 'auto',
            color: 'inherit',
        },
    }),
    valueContainer: (base) => ({
        ...base,
        gap: 0,
        ':hover': {
            gap: 0,
        },
    }),
    menu: (base) => ({ ...base, width: '12.5rem' }),
    option: (base) => ({
        ...base,
        fontWeight: 500,
        fontSize: '0.75rem',
        // text-base color
        color: '#242424',
    }),
    loadingIndicator: (base) => ({ ...base, color: 'inherit' }),
    dropdownIndicator: (base, state) => ({
        ...base,
        color: 'inherit',
        display: state.selectProps.isLoading ? 'none' : base.display,
    }),
};

type Props = {
    isUpdateLoading?: boolean;
    isDisabled?: boolean;
    value: creatorbase.FinanceStatus;
    onChange: (value: creatorbase.FinanceStatus) => void;
};

const SingleValue = (props: SingleValueProps<GenericDropdownOption<creatorbase.FinanceStatus>>) => {
    const value = getValue(props.getValue());
    return <div className={styles.financeStatusLabel}>{value?.label}</div>;
};

const FinanceStatusSelect = ({ value, onChange, isUpdateLoading, isDisabled }: Props) => {
    return (
        <div onClick={(e) => e.stopPropagation()}>
            <Select
                styles={selectStyles}
                isLoading={isUpdateLoading}
                isDisabled={isUpdateLoading || isDisabled}
                isMulti={false}
                isClearable={false}
                isSearchable={false}
                options={financeStatusOptions.filter((o) => o.value !== 'invoiced')}
                value={financeStatusOptions.find((o) => o.value === value)}
                onChange={(v) => onChange(v?.value!)}
                components={{ SingleValue }}
            />
        </div>
    );
};

export default FinanceStatusSelect;
